import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";
import { TrashIcon } from "@heroicons/react/20/solid";
import { useMatter } from "../../../contexts/MatterContext";
import { useTeamMember } from "../../../contexts/TeamMemberContext";

interface Props {
  teamMemberId: string;
}

const DeleteTeamMemberButton: React.FC<Props> = ({ teamMemberId }) => {
  const { deleteTeamMemberById } = useTeamMember();
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteing, setIsDeleteing] = useState(false);

  const handleSubmit = async () => {
    console.log("Deleting teamMember with ID:", teamMemberId);
    setIsDeleteing(true);
    try {
      await deleteTeamMemberById(teamMemberId);
      setIsOpen(false);
    } catch (error) {
      console.error("Error deleting teamMember:", error);
      alert("Failed to delete teamMember. Please try again later.");
    }
    setIsDeleteing(false);
  };

  return (
    <>
      <Button type="button" color="red" onClick={() => setIsOpen(true)}>
        <TrashIcon className="w-4 h-4" />
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Delete TeamMember</AlertTitle>
        <AlertDescription>
          Are you sure you want to delete this team member?
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={() => setIsOpen(false)} disabled={isDeleteing}>
            Cancel
          </Button>
          <Button color="red" onClick={handleSubmit} disabled={isDeleteing}>
            Delete
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default DeleteTeamMemberButton;
